import Container, { ContainerProps } from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import { ReactElement } from "react";

export type FullPageContainerDeprecatedProps = ContainerProps & {
  pageId?: string;
};

export const FullPageContainerDeprecated = ({
  children,
  pageId,
  ...props
}: FullPageContainerDeprecatedProps): ReactElement => (
  <Paper
    id={pageId}
    square
    elevation={0}
    sx={{
      ml: { md: 0.5 },
      width: (theme) => ({
        xs: "100%",
        md: `calc(100% - ${theme.spacing(0.5)})`,
      }),
      flex: 1,
      maxWidth: "100vw",
      height: "100vh",
      overflow: "auto",
    }}
  >
    <Container {...props}>{children}</Container>
  </Paper>
);
